import React, { useEffect, useState } from "react";
import { Menu, X, Radio } from "lucide-react";
import { profile } from "../mock/mock";
import { Button } from "./ui/button";

const links = [
  { label: "Reel", href: "/#reel" },
  { label: "Archive", href: "/#archive" },
  { label: "Vault", href: "/#vault" },
  { label: "About", href: "/#about" },
  { label: "Contact", href: "/#contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#0e0b09]/85 backdrop-blur-md border-b border-[#1f1a15]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <a href="#top" className="flex items-center gap-2 group">
          <span className="relative flex items-center justify-center w-8 h-8 rounded-md bg-[#1a1410] border border-[#2a221b]">
            <span className="absolute w-2 h-2 rounded-full bg-[#e4572e] rec-dot" />
            <Radio className="w-4 h-4 text-[#f2ece1]/70 ml-1.5" />
          </span>
          <div className="leading-tight">
            <div className="text-[13px] font-medium tracking-widest text-[#f2ece1]">
              {profile.studio.toUpperCase()}
            </div>
            <div className="text-[10px] mono text-[#f2ece1]/50">CH.03 // NTSC</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[13px] tracking-wide text-[#f2ece1]/70 hover:text-[#f2ece1] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <span className="text-[11px] mono text-[#f2ece1]/50">REC ● LIVE</span>
          <Button
            asChild
            className="h-9 px-4 bg-[#f2ece1] text-[#0e0b09] hover:bg-[#f5b14e] hover:text-[#0e0b09] rounded-full text-[13px] font-medium"
          >
            <a href="#contact">Book a Session</a>
          </Button>
        </div>

        <button
          className="md:hidden text-[#f2ece1]"
          onClick={() => setOpen((s) => !s)}
          aria-label="menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0e0b09] border-t border-[#1f1a15] px-6 py-4">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block py-3 text-sm text-[#f2ece1]/80 hover:text-[#f5b14e] border-b border-[#1f1a15]/60"
            >
              {l.label}
            </a>
          ))}
          <a
            href="/#contact"
            onClick={() => setOpen(false)}
            className="mt-4 inline-block bg-[#f2ece1] text-[#0e0b09] rounded-full px-4 py-2 text-sm"
          >
            Book a Session
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
